var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.chartConfig && _vm.chartConfig.chart_type)?_c('canvas',{ref:"chartCanvas"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }